import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Uncompromising Truth",
    text: "We cut through noise and spin to deliver essential reporting grounded in verified reality and deep investigative clarity.",
  },
  {
    n: "02",
    title: "Open Perspective",
    text: "Stories told without ideological blinders — embracing global nuance, human experience and multi-faceted insight.",
  },
  {
    n: "03",
    title: "Purposeful Depth",
    text: "Beyond clickbait headlines: meaningful journalism that empowers communities and informs a brighter tomorrow.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-16 max-w-2xl"
      >
        <p className="font-mono text-[11px] tracking-[0.35em] text-cyan-400">OUR MANIFESTO</p>
        <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-5xl">
          A new chapter in{" "}
          <span className="brand-gradient-text font-editorial font-normal italic">open journalism.</span>
        </h2>
      </motion.div>

      <div className="border-b border-white/10">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`manifesto-chapter-${c.n}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-1 gap-4 border-t border-white/10 py-10 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-12 md:gap-8 md:py-12"
          >
            <span className="font-mono text-xs tracking-[0.3em] text-cyan-400/90 md:col-span-2 md:pt-2">
              CHAPTER {c.n}
            </span>
            <h3 className="font-display text-2xl font-extrabold tracking-tight transition-colors duration-500 group-hover:text-cyan-300 sm:text-3xl md:col-span-4">
              {c.title}
            </h3>
            <p className="text-sm leading-relaxed text-slate-400 sm:text-base md:col-span-6 md:pt-1">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
